import { DashboardThemes } from '@/store/LayoutModule'

export default {
  data: () => ({
    dashboardThemes: DashboardThemes,
  }),
}
